import styled from 'styled-components/macro';
import * as colors from '../../../../../common/colorConstants';
import { TextInput } from '../../../../../common/formElements';

export const Container = styled.div`
  margin: 140px auto;
  width: 320px;
  display: flex;
  align-items: center;
  flex-direction: column;
  height: 100vh;
  text-align: center;
`;

export const FormContainer = styled.div`
  width: 100%;
  margin-top: 24px;
  padding: 24px 24px 14px;
  background-color: ${colors.lightGray7};
  font-family: Roboto, sans-serif;
`;

export const Row = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
`;

export const Label = styled.label`
  font-size: 11px;
  color: ${colors.lightBlack};
  font-weight: 400;
  margin-bottom: 0;
`;

export const InputWrapper = styled.div`
  position: relative;
  &::before {
    content: '$';
    position: absolute;
    font-size: 11px;
    line-height: 17px;
    top: 5px;
    left: 8px;
    opacity: 0.6;
  }
`;

export const Input = styled(TextInput)`
  width: 180px;
  font-size: 11px;
  line-height: 17px;
  padding: 4px 16px;
  font-weight: 500;
`;

export const ResultWrapper = styled.div`
  margin-top: 8px;
  padding-top: 14px;
  border-top: 1px solid ${colors.lightGray21};
  text-align: right;
`;

export const ResultValue = styled.span`
  margin-left: 6px;
  color: ${colors.lightBlack};
  font-size: 16px;
  font-weight: 500;
`;
